import PaperFlightGame from "./pages/PaperFlightGame";
import { AuthProvider } from "./context/AuthContext";
import { ToastProvider } from "./context/ToastContext";
function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <div className="App">
          <PaperFlightGame />
        </div>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;